// extracted by mini-css-extract-plugin
export var footer = "_ru-0";
export var inherit = "_ru-1";
export var input = "_ru-2";
export var modalContent = "_ru-3";
export var quillEditor = "_ru-4";
export var subtitle = "_ru-5";